import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from '@chama/ui-components/components/LoadingOverlay';

import ProductsForm from './ProductsForm';
import AddProductForm from './ProductsAddProductForm';
import ProductsTable from './ProductsTable';
import FormErrors from './ProductsFormErrors';
import FormActions from './ProductsFormActions';

import {
  checkIfMultimarcas,
  checkIfDealerCanAddProducts,
  checkIfDealerCanDeleteProducts,
  removeProductFromProducts,
  addProductToProducts,
  updateProducts,
  getAvailableBrands,
} from './DealerProductsLogic';

class DealerProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: props.products,
      editMode: false,
      addMode: false,
      deletingInProgress: false,
    };
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.products !== state.products) {
      return {
        products: nextProps.products,
        editMode: false,
        addMode: false,
      };
    }
    return null;
  }

  handleToggleEditMode = () => {
    this.setState(prevState => ({
      editMode: !prevState.editMode,
    }));
  };

  handleShowAddProductForm = () => this.setState({ addMode: true });

  handleHideAddProductForm = () => this.setState({ addMode: false });

  handleDealerProductDeletion = brand => {
    const { deleteDealerProduct } = this.props;
    const { products } = this.state;
    this.setState({ deletingInProgress: true }, () => {
      deleteDealerProduct(removeProductFromProducts({ products, brand })).then(() =>
        this.setState({ deletingInProgress: false }),
      );
    });
  };

  handleDealerProductAddition = product => {
    const { addDealerProduct } = this.props;
    const { products } = this.state;
    return addDealerProduct(addProductToProducts({ products, product }));
  };

  handleDealerProductsUpdate = update => {
    const { updateDealerProducts } = this.props;
    const { products } = this.state;
    return updateDealerProducts(updateProducts({ products, update }));
  };

  render() {
    const { representativeBrand } = this.props;
    const { addMode, editMode, products, deletingInProgress } = this.state;

    const isMultimarcas = checkIfMultimarcas({ representativeBrand });

    const dealerCanAddProducts = checkIfDealerCanAddProducts({ products, isMultimarcas });
    const dealerCanDeleteProducts = checkIfDealerCanDeleteProducts({ products, isMultimarcas });
    const brandsAvailableToAdd = getAvailableBrands({
      products,
      isMultimarcas,
      representativeBrand,
    });

    const hasProducts = products.length > 0;

    return (
      <div>
        <ProductsForm
          products={products}
          onHandleToggleEditMode={this.handleToggleEditMode}
          onUpdateDealerProducts={this.handleDealerProductsUpdate}
        >
          {formikProps => {
            const isSavingDisabled = Object.keys(formikProps.errors).length > 0;
            return (
              <Fragment>
                {(formikProps.isSubmitting || deletingInProgress) && <LoadingOverlay />}
                <ProductsTable
                  isEditing={editMode}
                  products={products}
                  dealerCanDeleteProducts={dealerCanDeleteProducts}
                  onDeleteDealerProduct={this.handleDealerProductDeletion}
                  errors={formikProps.errors}
                />
                <FormErrors errors={formikProps.errors} />
                <FormActions
                  hasProducts={hasProducts}
                  isEditing={editMode}
                  onToggleEditMode={this.handleToggleEditMode}
                  onShowAddProductForm={this.handleShowAddProductForm}
                  dealerCanAddProducts={dealerCanAddProducts}
                  isSavingDisabled={isSavingDisabled}
                  onResetForm={formikProps.resetForm}
                  onSubmitForm={formikProps.submitForm}
                />
              </Fragment>
            );
          }}
        </ProductsForm>
        {dealerCanAddProducts && addMode && (
          <AddProductForm
            products={products}
            brandsAvailableToAdd={brandsAvailableToAdd}
            onHideAddProductForm={this.handleHideAddProductForm}
            onAddDealerProduct={this.handleDealerProductAddition}
          />
        )}
      </div>
    );
  }
}
DealerProducts.propTypes = {
  products: PropTypes.array,
  representativeBrand: PropTypes.string.isRequired,
  updateDealerProducts: PropTypes.func.isRequired,
  addDealerProduct: PropTypes.func.isRequired,
  deleteDealerProduct: PropTypes.func.isRequired,
};
DealerProducts.defaultProps = {
  products: [],
};

DealerProducts.defaultProps = {
  products: [],
};

export default DealerProducts;



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/DealerProducts.jsx